export default "__VITE_ASSET__DaHElNrQ__"